document.addEventListener("DOMContentLoaded", () => {
  const messages = document.querySelectorAll(".announcement-bar .announcement-bar__message");

  messages.forEach(message => {
    const parentAnchor = message.closest("a");

    if (!parentAnchor) {
      message.style.cursor = "pointer";
    }

    message.addEventListener("click", (e) => {
      if (!parentAnchor) {
        e.preventDefault(); 
        const target = document.querySelector(".klaviyo-form");

        if (target) {
          const targetPosition = target.getBoundingClientRect().top + window.scrollY;
          const windowHeight = window.innerHeight;
          const targetCenterPosition = targetPosition - (windowHeight / 2) + (target.offsetHeight / 2);

          window.scrollTo({
            top: targetCenterPosition,
            behavior: "smooth"
          });
        }
      }
    });
  });
});
